import { Box } from '@mui/material';
import { bloxColors, bloxValues } from 'themes/constants';
import { useTranslation } from 'react-i18next';

type InvalidSourceOverlayProps = {
  message?: string;
};

/**
 * Overlay indicating the media source is unavailable.
 * The parent element must have `position: relative` (or similar) for this to layer correctly.
 */
const InvalidSourceOverlay = ({ message }: InvalidSourceOverlayProps) => {
  const { t } = useTranslation();
  const defaultMessage = t(
    'blox.video_field_input.error.no_file_playback',
    'File not available for playback',
  );
  const displayMessage = message ?? defaultMessage;

  return (
    <Box
      data-testid="invalid-source-overlay"
      sx={{
        position: 'absolute',
        inset: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'rgba(0,0,0,0.55)',
        color: bloxColors.white,
        fontSize: bloxValues.tinyFontSizeRem,
        textAlign: 'center',
        px: 2,
        boxSizing: 'border-box',
        width: '100%',
        maxWidth: '100%',
        pointerEvents: 'none',
        borderRadius: 'inherit',
        zIndex: 1,
      }}
    >
      <Box
        sx={{
          maxWidth: '100%',
          whiteSpace: 'normal',
          overflowWrap: 'break-word',
          wordBreak: 'break-word',
          px: 1,
        }}
      >
        {displayMessage}
      </Box>
    </Box>
  );
};
InvalidSourceOverlay.displayName = 'InvalidSourceOverlay';
export default InvalidSourceOverlay;
